import { render, staticRenderFns } from "./HotSaleProduct.vue?vue&type=template&id=56c9fcb4&scoped=true&"
import script from "./HotSaleProduct.vue?vue&type=script&lang=js&"
export * from "./HotSaleProduct.vue?vue&type=script&lang=js&"
import style0 from "./HotSaleProduct.vue?vue&type=style&index=0&id=56c9fcb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9fcb4",
  null
  
)

export default component.exports